exports.stroke = {
  ischemic: {
    code: 'ischemic',
    display: 'Ischemic',
    system: 'bcm',
  },
  hemorrhagic: {
    code: 'hemorrhagic',
    display: 'Hemorrhagic',
    system: 'bcm',
  },
};